export default "__VITE_ASSET__CwJyYav0__"